<template>
  <div class="item">
    <div v-if="from!=='profile'" class="item-header">
      <div class="avatar" @click="goRoute(item.user, item.id)">
        <img class="img" :src="(item.user.authority && item.user.authority.auth_avatar) || item.user.avatar || require('assets/imgs/padom.png')" :alt="item.user.nickname"  />
      </div>
      <div class="extra-view">
        <div class="link" @click="goRoute(item.user, item.id)">{{(item.user.authority && item.user.authority.auth_nickname) || item.user.nickname || '游客'}}</div>
        <span class="time">{{item.pub_time}}</span>
      </div>
      <!-- <button class="btn oparate-btn" @click.prevent="oparate('follow')">
        <span v-if="from == 'home' || from == 'detail'"  :class="{em: item.followed}">{{item.followed ? '已关注':'关注'}}</span>
      </button> -->
      <button class="btn oparate-btn" @click.prevent="oparate('follow')" v-if="from == 'home' || from == 'detail'" :class=" item.followed ? 'followed-btn' : 'follow-btn'">
        {{item.followed ? '已关注':'+关注'}}
      </button>
    </div>
    <div  class="item-body">
      <div v-if="item.isProducts">
        <div   class="table-box">
          <div class="t-header pc">
            我想「{{item.content.type}}」
            <router-link class="text-btn" :to="'/detail/'+item.id + '?typeId=' + id">查看详情<i class="iconfont icon-jiantou"></i></router-link>
          </div>
          <div class="t-body">
            <div class="t-flex">
              <div class="t-l pc">产品明细</div>
              <div class="t-r pc">联系人</div>
            </div>
            <div class="t-flex">
              <div class="t-l pc">
                <div v-for="p in item.content.products" class="product">{{p.name}},{{p.price}}元/公斤，{{p.num}}公斤</div>
              </div>
              <div class="t-r pc">{{item.content.contactName}}</div>
            </div>
            <div v-if="item.content.ways.length>0" class="ways pc">
              <p v-for="w in item.content.ways">·{{w}}</p>
            </div>
          </div>
        </div>
        <pre>{{item.content.content}}</pre>
      </div>
      <router-link v-else class="cc content" :to="'/detail/'+item.id + '?typeId=' + id">
      <pre v-html="item.content"></pre>
      
      </router-link>
      <div v-if="item.mediaType == 'video'" class="media-view">
        <div class="video-box">
          <video class="video" :ref="'video_'+index" :src="item.album[0]" @click="pause(index)" controls x5-playsinline playsinline webkit-playsinline x5-video-player-type="h5-page" x-webkit-airplay="true" x5-playsinline="true">
            您的浏览器不支持 video 标签。
          </video>
          <img v-show="index !== curIndex" class="img" :src="item.album[1] || item.album[0] + '?vframe/jpg/offset/1'" />
          <div v-show="index !== curIndex" class="play-btn iconfont icon-bofang" @click="play(index)">
        </div>
        </div>
      </div>
      <div v-if="item.mediaType == 'image'"  :class="item.album.length>1 ? 'media-view2 clearfix': 'media-view'">
        <div class="media" v-for="(media, index) in item.album">
          <img  :preview="item.id" class="pic" :src="media" />
        </div>
      </div>
    </div>
    <div v-if="item.address" class="address"><i class="sprite sprite-ditu"></i>{{item.address}}</div>
    <div v-if="from !== 'profile'" class="item-footer">
      <button class="btn" @click.prevent="oparate('zan')" :class="{em: item.is_liked}"><i class="sprite sprite-zan"></i>点赞{{item.like_count}}</button>
      <button class="btn" @click.prevent="oparate('comment')" ><i class="sprite sprite-huifu"></i>评论{{item.comment_count}}</button>
      <button class="btn" @click.prevent="share()"><i class="sprite sprite-zhuanfa"></i>分享</button>
      <!-- <button class="btn" @click.prevent="poster"><i class="iconfont icon-xiangce"></i>海报</button> -->
    </div>
    <div v-else class="item-footer">
      <span class="time">{{item.pub_time}}</span>
      <button v-if="is_it_self" class="btn2 em" @click.prevent="oparate('delete')"><i class="iconfont icon-shanchu"></i>删除</button>
    </div>
    <modal-share v-show="modalShare" @showModalShare="showModalShare"></modal-share>
  </div>
</template>
<script>
  import Modal from 'components/tips/Modal.vue';
  import { follow, zan, deleteContent } from 'assets/js/community.js';
  import {Env} from 'utils/util.js';
  import { share } from 'assets/js/share.js';
  import ModalShare from 'components/tips/ModalShare.vue';
  export default {
    name: 'ListItem',
    props: ['id', 'from', 'trdata', 'is_it_self', 'index'],
    data(){
      return {
        data: this.trdata,
        curIndex: '',
        tip: '',
        download: true,
        isApp: false,
        modalShare: false
      }
    },
    computed:{
      tokens(){
        return this.$store.state.tokens;
      },
      item:{
        get(){
          let item = this.data;
          if(/products/i.test(item.content)){
            item.content = JSON.parse(item.content);
            item.isProducts = true;
          }else if(/"content"/i.test(item.content)){
            item.content = JSON.parse(item.content);
            item.address = item.content.address;
            // item.content = item.content.content.replace(/#([^#]*)#/ig,"<a href='#' onclick='xxx()'>#$1#</a>");
            item.content = item.content.content;
          }
          console.log(item)
          item.content =  item.content.replace(/#([^#]*)#/ig,"<a class='topic-link' @click='console.log(1111)'>#$1#</a>")
          return item;
        },
        set(nV){
          this.data = nV; 
        }
      }
    },
    components:{
      Modal,
      ModalShare
    },
    created(){
      Env.isCGApp() && (this.isApp = true);
      if(!this.isApp){
        let item = this.item;
        let content = item.content.content || item.content;
        if(/<\/a>/.test(content)){
          content = content.replace(/(<\/?a.*?>)/g, '');
        }
        (content.length > 38) && (content = content.substr(0, 38) + '···');
        share({
          title: content,
          content: '来自川观新闻',
          imgUrl: item.album.length && item.album[0] && (/mp4/i.test(item.album[0]) ? item.album[1] : item.album[0]),
          link: `https://h5.chuanbaoguancha.cn/community/detail/${item.id}?typeId=${this.id}`
        });
      }
    },
    methods:{
      async oparate(type){
        let item = this.item, id='', temp = {};
        let tokens = this.tokens || await this.$store.dispatch('cbgcAuth');
        
        if(tokens.status){
          this.$emit('showTip', tokens.message);
          return;
        }else{
          tokens = typeof tokens == 'string' ? tokens : tokens.access_token;
        }
        switch(type){
          case 'follow':
            id = item.user.id;
            follow(id,tokens).then(res=>{
              temp.followed = res.data.followed;
              this.item = Object.assign({}, item, temp);
            });
          break;
          case 'zan':
            id = item.id;
            zan(id, tokens).then(res=>{
              temp.is_liked = res.data.is_liked;
              temp.like_count = res.data.like_count;
              this.item  = Object.assign({}, item, temp);
            });
          break;
          case 'delete':
            deleteContent(item.id, tokens).then(res=>{
              // todo
            });
          break;
          case 'comment':
            this.$router.push({
              name: 'Comment',
              params: {
                id: item.id
              },
              query:{
                typeId: this.id
              }
            });
          break;
        }
      },
      play(index){
        this.$refs['video_'+index].play();
        this.curIndex = index;
      },
      pause(index){
        this.$refs['video_'+index].pause();
        this.curIndex = '';
      },
      share(){
        this.modalShare = !this.isApp;
        let item = this.item;
        let content = item.content.content || item.content;
        if(/<\/a>/.test(content)){
          content = content.replace(/(<\/?a.*?>)/g, '');
        }
        (content.length > 38) && (content = content.substr(0, 38) + '···');
        share({
          // title: this.title,
          title: content,
          content: '来自观新闻',
          imgUrl: item.album.length && item.album[0] && (/mp4/i.test(item.album[0]) ? item.album[1] : item.album[0]),
          link: `https://h5.chuanbaoguancha.cn/community/detail/${item.id}?typeId=${this.id}`
        });
      },
      showModalShare(status){
        this.modalShare = status;
      },
      goRoute(user, cid){
        this.$router.push({
          name: 'Profile',
          params: {
            id: user.id
          },
          query:{
            from: 'detail',
            contentId: cid,
            nickname: user.nickname,
            avatar: user.avatar,
            is_authority: user.is_authority
          }
        });
      },
      poster(){

      }
      
    }
  }
</script>
<style lang="scss">
  pre{
    white-space: pre-line;
    text-align:justify;
    text-justify:inter-ideograph;
    .topic-link{
      color:#2f78f2!important
    }
  }
  .cc{
    display: block;
    cursor: pointer;
    position: relative;
    z-index: 10;
  }
  /* .item{
    padding: 1em;
    background-color: #fff;
    margin-bottom: 1em;
  } */
  .item-header{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    .btn{
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      .em{
        color: #da251d;
      }
    }
  }
  .extra-view{
    .link,.time{
      display: block;
    }
    .link{

    }
    .time{

    }
  }
  .oparate{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .item-body{
    margin-top: .3em;
    line-height: 1.5;
    .content{
      
    }
  }
  .media-view{
    margin: .5em auto .5em;
    overflow: hidden;
    position: relative;
    max-width: 100%;
    max-height: 250px;
    .media, .video, .video+.img{
      max-width: 100%;
      max-height: 250px;
    }
    .img{
      width: 100%;
      position: absolute;
      left:0;top:0;
      z-index: 1;
    }
    .pic{
      max-width: 100%;
      max-height: 250px;
    }
    .media{
      /* width: 100%; */
    }
    .video-box{
      display: inline-block;
      position: relative;
    }
    .video + .img{
      /* width: 100%; */
      width: auto;
    }
    .play-btn{
      position: absolute;
      left: 50%;top:50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      font-size: 3.6em;
      color: #da251d;
    }
  }
  .media-view2{
    margin: .5em auto .5em;
    .media{ 
      display: block;
      float: left;
      margin: 0;padding:0;
      width: 30vw;
      height: 30vw;
      overflow: hidden;
      margin: 0 1.3vw 1.3vw 0;
      border: 1px solid #ecf2f5;
      box-sizing: border-box;
      position: relative;
      &:nth-child(3n+3){
        margin-right: 0;
      }
      .pic{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .item-footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    border-top: 1px solid #eee;
    padding-top: .5em;
    .btn{
      flex: 1;
      line-height: 2;
    }
    .em{
      color: #da251d;
    }
  }
  .mescroll-totop{
    right: .5em;
    bottom: .3em;
    font-size: 2.2em;
    width: 1.8em;
    height: 1.8em;
  }
  .em{
    color: #da251d;
  }
  .hide{
    display: none;
  }
</style>